"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const ThemeContext_1 = require("../../../interface/ThemeContext");
const connector = (0, react_redux_1.connect)((state) => ({}), (dispatch) => ({}));
exports.default = connector(({}) => {
    const themeContext = (0, ThemeContext_1.useThemeContext)();
    const currentColor = themeContext.colors.white;
    const founderInformation = [
        {
            name: "Andrew Bloodworth",
            description: "Andrew Bloodworth harnesses over a decade of technical leadership to drive product innovation and strategic direction, ensuring our solutions set industry standards. His expertise is pivotal to our company's technological forefront.",
            imagePath: "/assets/images/leadership/andrew_bloodworth.png",
            link: "",
            title: "Co-Founder",
        },
        {
            name: "Dylan Hoffman",
            description: "Dylan Hoffman has spent a decade driving automation and efficiency for SaaS organizations. With extensive experience in technology solutions, his focus on optimizing processes and boosting financial performance has been instrumental in helping businesses streamline operations and achieve sustainable growth.",
            imagePath: "/assets/images/leadership/dylan_hoffman.png",
            link: "",
            title: "Co-Founder",
        },
    ];
    return (react_1.default.createElement("div", { className: "founders-outer-container", id: "founders-container" },
        react_1.default.createElement("div", { className: "container px-6 founders-header" },
            react_1.default.createElement("h2", { className: "pt-6", style: {
                    alignSelf: "stretch",
                    color: " #0e2238",
                    /* font-family: Inter; */
                    fontSize: 45,
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "95%",
                    letterSpacing: "-2px",
                } }, "Our Leadership")),
        react_1.default.createElement("div", { className: "founders-inner-container container" }, founderInformation.map((founder, index) => (react_1.default.createElement("div", { className: "individual-founder", style: Object.assign({}, (() => index % 2 !== 0
                ? {
                    flexDirection: "row-reverse",
                }
                : {})()) },
            react_1.default.createElement("div", { className: "individual-founder-info-container" },
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                    } },
                    react_1.default.createElement("h3", { className: "mb-0" }, founder.name),
                    react_1.default.createElement("p", { className: "mb-0 individual-founder-info-title" }, founder.title)),
                react_1.default.createElement("p", { className: "mb-0 individual-founder-info-description" }, founder.description)),
            react_1.default.createElement("div", { className: "individual-founder-image-container" },
                react_1.default.createElement("div", { className: "individual-founder-image-backdrop" },
                    react_1.default.createElement("img", { src: founder.imagePath }),
                    react_1.default.createElement("div", null)),
                react_1.default.createElement("div", { className: "founder-name-title" },
                    react_1.default.createElement("h4", { className: "mb-0" }, founder.name),
                    react_1.default.createElement("p", { className: "mb-0" }, founder.title)))))))));
});
